module.exports = __webpack_public_path__ + "img/google-maps.50544b19.gif";